import styles from "./Anonymous.module.scss"

import React, { MouseEvent } from "react"

import {useLayerPopupContext, useSchedule} from "@shared/contexts"
import {redirectLoginUrl} from "../../modules";

function Anonymous() {
  const { close } = useLayerPopupContext()
  const { schedule } = useSchedule()

  return (
    <React.Fragment>
      <article className="popup" style={{ margin: "-150px 0 0 -250px" }}>
        <div className="titB">
          <h1>알림</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <p>로그인이 필요한 서비스입니다.</p>
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="방송종료하고 로그인하기"
            className={styles.wide}
            onClick={(e: MouseEvent) => {
              e.preventDefault()

              redirectLoginUrl(schedule!.id)
              // if (process.env.REACT_APP_DOMAIN) {
              //   window.document.domain = process.env.REACT_APP_DOMAIN
              // }
              //
              // const opener = window.opener
              // let location = window.location
              // let ref = window.document.URL
              // try {
              //   if (opener) {
              //     location = opener.location
              //     ref = opener.document.URL
              //   }
              // } catch {
              //   ref = ""
              // }
              //
              // try {
              //   ref = window.encodeURIComponent(ref)
              //   window.open(
              //     `https://login.wowtv.co.kr/sso/login?ReturnUrl=${ref}`,
              //   )
              // } catch {
              //   window.open("", "_self", "")
              //   window.close()
              //   const customWindow = window.open("", "_blank", "")
              //   customWindow?.close()
              // } finally {
              //   window.open("", "_self", "")
              //   window.close()
              //   const customWindow = window.open("", "_blank", "")
              //   customWindow?.close()
              // }
            }}
          >
            방송종료하고 로그인하기
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default Anonymous
